window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    var instance = new Swiper('.reviews__reviews-list-wrapper.swiper', {
      slidesPerView: 1,
      spaceBetween: 20,
      allowTouchMove: true,
      enabled: true,
      navigation: {
        nextEl: '.reviews__navigation-wrapper .swiper-button-next',
        prevEl: '.reviews__navigation-wrapper .swiper-button-prev',
      },
      breakpoints: {
        1279: {
          slidesPerView: 2,
          spaceBetween: 30,
          allowTouchMove: true,
          enabled: true,
        },
        1280: {
          slidesPerView: 'auto',
          spaceBetween: 0,
          allowTouchMove: false,
          enabled: false,
        },
      },
      on: {
        resize: function (swiper) {
          swiper.setTranslate(0);
        },
      },
    });
  });
});
